import React from 'react';
import LookupItemService from '../../../../../Services/LookupItemService';
import LoadingIcon from '../../../../LoadingIcon';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';

export default class LookupItemMiscMultiChoice extends React.Component {
  static defaultProps = {
    lookupId: 116,
    lookupItemValue: 1,
    separatorCharacter: ',',
    label: '',
    onChange: () => alert('LookupItemMiscMultiChoice Onchange'),
    selected: [],
    fieldName: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    LookupItemService.GetLookupItemByLookupIdAndLookupItemId(this.props.lookupId, this.props.lookupItemId)
      .then((result) => {
        const optValues = [];
        const selected = [];
        const misc = result.misc;
        const miscArray = misc.split(this.props.separatorCharacter);
        miscArray.forEach((miscValue) => {
          const newValue = { label: miscValue, value: miscValue };
          optValues.push(newValue);
        });

        this.setState({
          itemList: optValues,
          loading: false,
          selected,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('LMC57');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected });
    this.props.onChange(selected);
  }

  renderList() {
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={this.props.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100 text-center hover rounded arial'>
        {this.props.label && (
          <label
            className='m-0 p-0 defaultfontsize '
            htmlFor={'htmlidfor' + this.props.fieldName}
          >
            {this.props.label}
          </label>
        )}
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
